import {MaterialDemandByDay} from '@domain/material-demand'
import {useUpmPlantContext} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'
import {useCallback} from 'react'

import {getCombinedDemandDataDaily} from '../../../selectors'
import {type MomentRange, convertToDate} from '../../../utils'
import {fetchMaterialDemand, salesForecastQueryKeys} from '../backend'

interface MaterialDemandDailyQueryParams {
  timeframe: MomentRange
  timezoneId: string
  materialIds: number[]
}

/**
 * Hook used for the demand chart – combines all selected materials data into a daily aggregate.
 */
export const useMaterialDemandDailyQuery = ({
  timeframe,
  timezoneId,
  materialIds
}: MaterialDemandDailyQueryParams) => {
  const {plantId: plantCode} = useUpmPlantContext()
  const fromDate = convertToDate(timeframe[0].clone().tz(timezoneId))
  const toDate = convertToDate(timeframe[1].clone().tz(timezoneId))

  const selector = useCallback(
    (data: MaterialDemandByDay) =>
      getCombinedDemandDataDaily(data, materialIds.length === 0 ? undefined : materialIds),
    [materialIds]
  )

  return useQuery({
    queryKey: [salesForecastQueryKeys.materialDemand, plantCode, {fromDate, toDate}],
    queryFn: ({signal}) => fetchMaterialDemand(plantCode, fromDate, toDate, signal),
    select: selector,
    throwOnError: true
  })
}
